import * as React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { cn } from "../../lib/utils";

export const Sheet = DialogPrimitive.Root;
export const SheetTrigger = DialogPrimitive.Trigger;
export const SheetClose = DialogPrimitive.Close;

export function SheetContent({ className, children, side = "right", ...props }) {
  return (
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay className="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out" />
      <DialogPrimitive.Content
        className={cn(
          "fixed z-50 bg-[hsl(var(--bg-elev-1))] border border-[hsl(var(--border))] shadow-[0_10px_60px_-20px_rgba(0,0,0,0.7)] flex flex-col",
          side === "right"
            ? "top-0 right-0 h-full w-full sm:w-[420px] sm:rounded-l-[var(--radius)]"
            : "top-0 left-0 h-full w-full sm:w-[420px] sm:rounded-r-[var(--radius)]",
          className
        )}
        {...props}
      >
        {children}
        <DialogPrimitive.Close
          className="absolute top-3 right-3 rounded-md p-1.5 text-[hsl(var(--muted))] hover:bg-[hsl(var(--bg-elev-2))]"
          aria-label="Close"
        >
          <X size={16} />
        </DialogPrimitive.Close>
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  );
}

export function SheetHeader({ className, ...props }) {
  return (
    <div
      className={cn("px-5 pt-5 pb-3 border-b border-[hsl(var(--border))]", className)}
      {...props}
    />
  );
}
export function SheetTitle({ className, ...props }) {
  return (
    <DialogPrimitive.Title
      className={cn("text-base font-semibold tracking-wide", className)}
      {...props}
    />
  );
}
export function SheetBody({ className, ...props }) {
  return <div className={cn("flex-1 overflow-y-auto p-3", className)} {...props} />;
}
export function SheetFooter({ className, ...props }) {
  return (
    <div
      className={cn("px-5 py-3 border-t border-[hsl(var(--border))]", className)}
      {...props}
    />
  );
}
